import { useSelector } from 'react-redux';
import { getSuitCaseData } from '../ducks';

export const useGetCasePrice = () => {
  const { data } = useSelector(getSuitCaseData);
  return {
    price: data.lastRevision.price,
  };
};
